export default __webpack_public_path__ + "static/media/image.f995f014.png";